// ** Third Party Components
import React from 'react';
import classnames from 'classnames';
import { Spinner } from 'reactstrap';

import './ui-loader.scss';

interface Props {
  tag?: keyof JSX.IntrinsicElements;
  loader?: JSX.Element;
  className?: string;
  overlayColor?: string;
  blocking?: boolean;
  zIndex?: number;
  style?: React.CSSProperties;
  loaderStyle?: React.CSSProperties;
}

export const UILoader: React.FC<Props> = ({
  tag = 'div',
  loader = <Spinner color="primary" />,
  className = '',
  overlayColor = 'rgba(255, 255, 255, .5)',
  blocking = false,
  children,
  zIndex,
  style,
  loaderStyle,
}) => {
  const Tag = tag;

  return (
    <Tag
      className={classnames('ui-loader', {
        [className]: className,
        show: blocking,
      })}
      style={style}
    >
      {children}
      {blocking ? (
        <>
          <div
            className="overlay"
            style={{ zIndex, backgroundColor: overlayColor }}
          />
          <div className="loader" style={{ zIndex, ...loaderStyle }}>
            {loader}
          </div>
        </>
      ) : null}
    </Tag>
  );
};
